import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import * as actionTypes from "../../../store/actions";

const RulesSideBarItem = (props) => {
  const onClickSideBarRule = () => {
    switch (props.type) {
        case "rules":
          props.setLoadedRule(props.rulesArray.rules.items[props.ruleId - 1]);
          break;
        case "signs":
          props.setLoadedRule(props.rulesArray.signs.items[props.ruleId - 1]);
          break;
        case "marks":
          props.setLoadedRule(props.rulesArray.marks.items[props.ruleId - 1]);
          break;
        case "access":
          props.setLoadedRule(props.rulesArray.access.items[props.ruleId - 1]);
          break;
        default:
          break;
      }
      window.scrollTo(0, 0);
      if (props.closeSideBarMobile) props.closeSideBarMobile();
      
  };

  return (
    <Link
      onClick={onClickSideBarRule}
      className="ticket-item-link"
      to={`/${props.type}/${props.ruleId}/`}
    >
      <div
        className={
          "rule-item " +
          (props.isActiveTicketItem ? "active-ticket-item" : "")
        }
      >
       <b>{props.ruleId}.</b> {props.header}
      </div>
    </Link>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoadedRule: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),

  };
};

export default connect(null, mapDispatchToProps)(RulesSideBarItem);
